<template>
	<div class="tgju-widget light post mb-3">
		<div class="post-input-box" ref="post-input-box">
			<form @submit.prevent="">
				<Mentionable
					:keys="['@']"
					:items="mentionItems"
					offset="6"
					insert-space
					@open="mentionOnOpen"
				>
					<Editable v-model="$parent.newPost.content" class="autosize dashboard-post-textarea textarea-post twemojiTextarea" ref="textarea-post" placeholder="متن خود را بنویسید ..."></Editable>

					<template #no-result>
						<div class="dim">
							No result
						</div>
					</template>

					<template #item-@="{ item }">
						<div class="item">
							{{ item.value }}
							<span class="dim">
								({{ item.username }})
							</span>
						</div>
					</template>
				</Mentionable>

				<div class="dashboard-post-preview-image" v-if="_newPost.attachments.length">
					<div v-for="attachment in _newPost.attachments" :key="attachment.id" class="dashboard-post-preview-data">
						<div class="preview_image-delete" @click="removeAttachment(attachment.id)"><i class="uil uil-times-circle" aria-hidden="true"></i></div>
						<img class="preview-image" :src="$helpers.api_url() + attachment.name" alt="" />
					</div>
				</div>

				<div class="dashboard-post-btn">
					<div class="tgju-btn tgju-btn-primary" @click="sendPost()">
						<i class="uil uil-comment-plus" aria-hidden="true"></i>
						<template>{{ $parent.newPost.id ? 'ویرایش نظر' : 'ارسال نظر' }}</template>
					</div>
					<div class="m-right tgju-btn tgju-btn-danger" @click="resetNewPost()" v-if="newPost.content.length">
						<i class="uil uil-times" aria-hidden="true"></i>
						انصراف
					</div>
					<div class="dashboard-post-btn-left">
						<!-- <label>
							<div class="dropdown mention">
								<i class="fa fa-at dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-hidden="true"></i>
								<div class="dropdown-menu">
									<input type="text" class="mention-input" placeholder="نام  یا آی دی را وارد نمایید" />
									<ul class="mention-list">
										<li onClick="add_mention('textarea-post',12,'@ali_farmani')">
											<div class="img">
												<img src="https://static.tgju.org/views/default/images/avatar.jpg">
											</div>
											<div class="title">
												<div class="name"> اول</div>
												<div class="id">@ali_farmani</div>
											</div>
										</li>
										<li onClick="add_mention('textarea-post',12,'@farmani')">
											<div class="img">
												<img src="https://static.tgju.org/views/default/images/avatar.jpg">
											</div>
											<div class="title">
												<div class="name"> دوم</div>
												<div class="id">@farmani</div>
											</div>
										</li>
										<li onClick="add_mention('textarea-post',12,'@ali')">
											<div class="img">
												<img src="https://static.tgju.org/views/default/images/avatar.jpg">
											</div>
											<div class="title">
												<div class="name"> سوم</div>
												<div class="id">@ali</div>
											</div>
										</li>
									</ul>

								</div>
							</div>
						</label> -->
						<label v-tooltip="'افزودن شکلک'">
							<twemoji-picker :emojiData="emojiDataAll" :emojiGroups="emojiGroups" :skinsSelection="false" :searchEmojisFeat="true" searchEmojiPlaceholder="جستجو کنید ..." searchEmojiNotFound="ایموجی یافت نشد" isLoadingLabel="درحال بارگزاری ..."></twemoji-picker>
						</label>
						<label :for="file_input_name" class='dashboard-post-btn-file' v-tooltip="'آپلود عکس'">
							<input type="file" :id="file_input_name" class="btn-file-pic" label="add" @change="uploadAttachment($event.target.files)" />
							<i class="uil uil-image-plus" aria-hidden="true"></i>
						</label>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script> 
	import {
		TwemojiPicker,
		EmojiService
	} from '@kevinfaguiar/vue-twemoji-picker';
	import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json';
	import EmojiDataAnimalsNature from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-group-animals-nature.json';
	import EmojiDataFoodDrink from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-group-food-drink.json';
	import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
	
	import Editable from '@/components/Editable.vue'
	import { Mentionable } from 'vue-mention';

	export default {
		name: 'PostSend',
		components: {
			'twemoji-picker': TwemojiPicker,
			Editable,
			Mentionable
		},
		props: ['newPost'],
		data: function () {
			return {
				mentionItems: [],
				users: [
					{
						value: 'm.foroughi',
						username: 'm.foroughi',
					},
					{
						value: 'a.farmani',
						username: 'a.farmani',
					}
				],
				file_input_name: 'file_input_' + Math.random().toString(36).substring(7),
			}
		},

		computed: {
			emojiDataAll() {
				return EmojiAllData;
			},

			emojiGroups() {
				return EmojiGroups;
			},

			_newPost: {
				get() {
					return this.$parent.newPost;
				},
				set(value) {
					this.$parent.newPost = value;
				}
			},

			type() {
				return this.newPost.type;
			}
		},

		watch: {
			newPost: {
				handler: function (newValue, oldValue) {
					if ( Object.keys(newValue).length && ( typeof oldValue == 'undefined' || !Object.keys(oldValue).length ) ) {
						//
					}
				},
				immediate: true
			}
		},

		mounted() {
			let self = this;
			let post_input_box = $(this.$refs['post-input-box']);
			$(document).on('click', '#emoji-container > #emoji-popup .emoji-popover-inner > div > .emoji-list > span > img', function () {
				if ( post_input_box.find('#popper-container').is(":visible") ) {
					self.$parent.newPost.content = self.$parent.newPost.content + self.parseEmoji($(this).attr('alt'));
				}
			});
		},

		methods: {
			uploadAttachment(fileList) {
				let attachment = [];
				if (fileList.length) {
					attachment = fileList[0];
				} else {
					attachment = null;
				}

				if (attachment) {
					let api_data = {
						attachment
					};

					if (this.newPost.attachments.length) {
						this.removeAttachment(this._newPost.attachments[0].id);
					}

					this.$helpers.makeRequest('POST', '/post/upload', api_data).then(api_response => {
						this.$helpers.api_alert(api_response);

						if (api_response.status == 200) {
							let response = api_response.data.response;

							this.newPost.attachments.push(response);
						}
					});
				}
			},

			removeAttachment(id) {
				let index = this.$helpers.getIndex(this._newPost.attachments, id);
				let attachment = this._newPost.attachments[index];

				let api_data = {
					image: attachment.name.split('/').reverse()[0]
				};

				this.$helpers.makeRequest('DELETE', '/post/remove-attachment/', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if (api_response.status == 200) {
						this._newPost.attachments.splice(index, 1);
					}
				});
			},

			parseEmoji(str) {
				str = EmojiService.getEmojiImgFromUnicode(str);
				str = str.replaceAll(/alt=".*?"/igm, '');
				return str;
			},

			parseNewPostContent(e) {
				// this._newPost.content = this.parseEmoji(e.target.innerHTML);
				// setTimeout(() => {
				// 	this.setCaretToEnd(this.$refs['textarea-post']);
				// }, 1);
			},

			setCaretToEnd(target /*: HTMLDivElement*/ ) {
				const range = document.createRange();
				const sel = window.getSelection();
				// range.selectNodeContents(target);
				range.collapse(false);
				sel.removeAllRanges();
				sel.addRange(range);
				// target.focus();
				range.detach(); // optimization

				// set scroll to the end if multiline
				target.scrollTop = target.scrollHeight;
			},

			scrollTo(container) {
				this.$scrollTo(this.$refs['textarea-post'], 500, {
					container,
					offset: ( container == 'body' ) ? -130 : -20
				});
			},

			sendPost() {
				if ( !this._newPost.content.trim() ) return;

				if ( this._newPost.id ) {
					return this.editPost();
				}

				let api_data = {
					content: this._newPost.content,
					type: this._newPost.type,
					parent_id: this._newPost.parent_id,
					subject: this._newPost.subject,
					attachments: JSON.stringify(this._newPost.attachments),
				};

				if ( this.type == 'tgju-comment' ) {
					api_data.post_id = this.$parent.post.id;
				}

				this.$helpers.makeRequest('POST', '/tgju-post/store', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						this.$toast.success({
							title: 'پست ها',
							message: `${this.type == 'tgju-post' ? 'پست' : 'نظر'} جدید شما با موفقیت ثبت شد`
						});

						let post = api_response.data.response.post;

						if ( this.type == 'tgju-post' ) {
							if ( this._newPost.parent_id ) {
								post.parent = this._newPost.parent;
								this.$parent.closeModal();
							}
							
							this.$parent.posts.data.unshift(post);
						} else {
							if ( this._newPost.parent.type == 'tgju-comment' ) {
								this._newPost.parent.comments.unshift(post);
							} else {
								this.$parent.commentsRefreshEvent = Math.random();
							}
							
							this.$parent.post.comments_count += 1;
						}

						this.resetNewPost();
					}
				});
			},

			editPost() {
				let post = []
				if ( this._newPost.type == 'tgju-comment' ) {
					post = this._newPost;
				} else {
					let index = this.$helpers.getIndex(this.$parent.posts.data, this._newPost.id);
					post = this.$parent.posts.data[index];
				}
				
				let api_data = {
					content: this._newPost.content,
					attachments: JSON.stringify(this._newPost.attachments),
				};

				this.$helpers.makeRequest('POST', '/tgju-post/edit/' + post.id, api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					post.content = this._newPost.content;
					post.attachments = this._newPost.attachments;

					if ( api_response.status == 200 ) {
						this.$toast.success({
							title: 'پست ها',
							message: 'پست شما با موفقیت ویرایش شد'
						});
						
						if ( this._newPost.type == 'tgju-comment' ) 
							this.$parent.commentsRefreshEvent = Math.random();

						if ( post.attachments.length ) {
							post.content += `<br><img class="post-img" src="${post.attachments[0].name}">`;
						}

						this.resetNewPost();
					}
				});
			},

			resetNewPost() {
				this._newPost.id = null;
				this._newPost.attachments = [];
				this._newPost.comments = [];
				this._newPost.content = '';
				this._newPost.created_at = null;
				this._newPost.liked = false;
				this._newPost.likes = 0;
				this._newPost.parent_id = 0;
				this._newPost.reshares = 0;
				this._newPost.saved = false;
				this._newPost.user = null;
				this._newPost.user_id = null;
				
				if(this.newPost.type == 'tgju-comment') {
					let parent = this.$helpers.getParent(this);
					parent.resetReply();
				}

			},
			
			mentionOnOpen (key) {
				if ( key === '@' ) {
					this.mentionItems = this.users;
				}
			},
		}
	}
</script>
